import { useNavigate } from "react-router-dom";
import { hasAdminRole } from "../store/AclUtil";
import { useAuth } from "../store/auth/hooks";
import VersionTag from "./VersionTag";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  useTheme,
} from "@mui/material";
import {
  ArticleOutlined,
  GraphicEqOutlined,
  PeopleAlt,
} from "@mui/icons-material";
import { useDrawer } from "../store/drawer/hooks";

export default function MainMenu() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdmin = hasAdminRole(user);
  const { closeDrawer, showDrawer } = useDrawer();

  const navigateCases = async () => {
    closeDrawer();
    navigate("/app/cases");
  };

  const navigateUsers = async () => {
    closeDrawer();
    navigate("/app/admin/users");
  };

  const navigateLicense = async () => {
    closeDrawer();
    navigate("/app/admin/license");
  };

  const listItemTypography = {
    primary: {
      fontSize: 14,
      fontWeight: 500,
      letterSpacing: 2,
    },
  };

  return (
    <Drawer
      aria-hidden={!showDrawer}
      onClose={() => closeDrawer()}
      open={showDrawer}
      ModalProps={{
        keepMounted: true,
      }}
      slotProps={{
        paper: {
          sx: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.common.black,
            width: 200,
          },
        },
      }}
      variant="temporary"
    >
      <Stack alignItems="center" height={1} justifyContent="space-between">
        <Box pt={8} role="presentation" width={1}>
          <List>
            <ListItem
              key={"Cases"}
              disablePadding
              onKeyDown={() => closeDrawer()}
            >
              <ListItemButton onClick={navigateCases}>
                <ListItemIcon>
                  <GraphicEqOutlined
                    sx={{ color: theme.palette.common.black, opacity: 0.5 }}
                  />
                </ListItemIcon>
                <ListItemText primary="CASES" slotProps={listItemTypography} />
              </ListItemButton>
            </ListItem>
            {isAdmin && (
              <ListItem
                key={"Users"}
                disablePadding
                onKeyDown={() => closeDrawer()}
              >
                <ListItemButton onClick={navigateUsers}>
                  <ListItemIcon>
                    <PeopleAlt
                      sx={{ color: theme.palette.common.black, opacity: 0.5 }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary="USERS"
                    slotProps={listItemTypography}
                  />
                </ListItemButton>
              </ListItem>
            )}
            {isAdmin && (
              <ListItem
                key={"License"}
                disablePadding
                onKeyDown={() => closeDrawer()}
              >
                <ListItemButton onClick={navigateLicense}>
                  <ListItemIcon>
                    <ArticleOutlined
                      sx={{ color: theme.palette.common.black, opacity: 0.5 }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary="LICENSE"
                    slotProps={listItemTypography}
                  />
                </ListItemButton>
              </ListItem>
            )}
          </List>
        </Box>
        <VersionTag />
      </Stack>
    </Drawer>
  );
}
